module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "col-span-12 intro-y"
  }, [_c('div', [(_vm.series.length > 0) ? _c('div', {
    staticClass: "my-2"
  }, [(_vm.start_date) ? _c('div', {
    staticClass: "flex flex-row justify-between mb-2"
  }, [_c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Reporte de horas por mes")]), _vm._v(" "), _c('span', {
    staticClass: "border rounded p-2"
  }, [_vm._v(_vm._s(_vm.start_date) + " a " + _vm._s(_vm.end_date))])]) : _vm._e(), _vm._v(" "), _c('VueApexCharts', {
    attrs: {
      "width": "100%",
      "height": "500",
      "type": "bar",
      "options": _vm.options,
      "series": _vm.series
    }
  })], 1) : _vm._e()])]) : _c('div', {
    staticClass: "col-span-12 intro-y"
  }, [_c('Loading')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc4278a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/report/partials/TasksMonthsAccount.vue
// module id = 475
// module chunks = 1